import { cva, type VariantProps } from "class-variance-authority";
import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "../lib/cn";

/**
 * Нейтральный чип метаданных: r4, высота 20, подпись 13px Geist Mono.
 * `cool` — холодная заливка для чипов на «шапке» профиля и в реестре Баллов,
 * `brand` — зелёный 32%, акцент идентичности (единственная зелёная роль здесь).
 */
const statusChipVariants = cva(
	"inline-flex h-5 w-fit items-center whitespace-nowrap rounded-chip text-fg t-num-xs",
	{
		variants: {
			tone: {
				default: "bg-chip",
				cool: "bg-chip-cool",
				brand: "bg-chip-brand",
			},
			hasIcon: {
				true: "gap-0.5 py-px pr-1.5 pl-0.5",
				false: "gap-1 px-1.5 py-px",
			},
		},
		defaultVariants: { tone: "default", hasIcon: false },
	},
);

export interface StatusChipProps
	extends HTMLAttributes<HTMLSpanElement>,
		Omit<VariantProps<typeof statusChipVariants>, "hasIcon"> {
	icon?: ReactNode;
	children?: ReactNode;
}

export function StatusChip({ tone, icon, className, children, ...rest }: StatusChipProps) {
	return (
		<span className={cn(statusChipVariants({ tone, hasIcon: icon != null }), className)} {...rest}>
			{icon}
			{children}
		</span>
	);
}

export { statusChipVariants };
